import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { http, apiError, money } from "@/lib/shop";

const TYPE = {
  in: { label: "Added", cls: "bg-emerald-50 text-emerald-700" },
  out: { label: "Removed", cls: "bg-slate-100 text-slate-700" },
  used: { label: "Used in repair", cls: "bg-brand-50 text-brand-700" },
};

export const MovementHistory = ({ owner, partId, compact = false }) => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    http.get("/movements", { params: partId ? { part_id: partId } : {} }).then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  }, [partId]);
  useEffect(() => { load(); }, [load]);

  if (items === null) return <p className="mt-6 text-sm text-slate-500">Loading…</p>;

  return (
    <div className={compact ? "" : "mt-6"} data-testid="movement-history">
      {!compact && (
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm text-slate-600">Latest {items.length} stock movements</p>
          <button onClick={load} className="inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-brand" data-testid="history-refresh-btn"><RefreshCw className="h-4 w-4" /> Refresh</button>
        </div>
      )}
      {!items.length && <p className="text-sm text-slate-500" data-testid="history-empty">No stock movements yet.</p>}
      <div className="grid gap-2">
        {items.map((m) => (
          <div key={m.id} className="bg-white rounded-xl border border-slate-200 p-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`movement-${m.id}`}>
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${TYPE[m.type].cls}`}>{TYPE[m.type].label}</span>
            {!partId && <span className="font-bold">{m.part_name}</span>}
            <span className="font-display font-bold">{m.type === "in" ? "+" : "−"}{m.quantity}</span>
            <span className="text-slate-500">→ {m.quantity_after} left</span>
            {m.repair_label && <span className="text-slate-600">for {m.repair_label}</span>}
            {m.note && <span className="text-slate-500 italic">“{m.note}”</span>}
            {owner && m.unit_cost != null && <span className="text-slate-500">cost {money(m.unit_cost)}</span>}
            {owner && m.profit != null && <span className="font-semibold text-emerald-700" data-testid={`movement-profit-${m.id}`}>profit {money(m.profit)}</span>}
            <span className="ml-auto text-xs text-slate-400">{new Date(m.created_at).toLocaleString("en-GB")} · {m.user_email}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
